import { useCallback, useEffect, useState } from "react";

export type FreelancersViewMode = "grid" | "wide" | "list";

const STORAGE_KEY = "freelancers.view_mode";
const DEFAULT_MODE: FreelancersViewMode = "grid";
const VALID: FreelancersViewMode[] = ["grid", "wide", "list"];

function readStored(): FreelancersViewMode {
  if (typeof window === "undefined") return DEFAULT_MODE;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return VALID.includes(raw as FreelancersViewMode)
    ? (raw as FreelancersViewMode)
    : DEFAULT_MODE;
}

export function useFreelancersViewMode() {
  const [mode, setModeState] = useState<FreelancersViewMode>(readStored);

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) setModeState(readStored());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const setMode = useCallback((next: FreelancersViewMode) => {
    window.localStorage.setItem(STORAGE_KEY, next);
    setModeState(next);
  }, []);

  return { mode, setMode };
}
